"use client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAlignRight,
  faArrowRight,
  faFileEdit,
  faHouse,
  faPlane,
} from "@fortawesome/free-solid-svg-icons";
import * as ReactDOM from "react-dom";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
//import "react-toastify/dist/ReactToastify.css";
import Image from "next/image";
import React, { useState, useEffect, useRef } from "react";
import { useBookingEngineContext } from "../../cin_context/BookingEngineContext";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import StayStepRoomManager from "./StayStepRoomManager";
import "flatpickr/dist/themes/material_green.css";
import "bootstrap/dist/css/bootstrap.min.css";
import DatePicker from "./DatePicker";
import { createSignature } from "../../../app/utilities/signature";
import { ChevronDown, ChevronUp, ChevronsUp } from "lucide-react";
import { getUserInfo } from "../../../app/utilities/userInfo";
import { isValidDate } from "../../../app/utilities/validDate";

const StayStep = ({ goNext, onClose, onSend,isVisible, backgroundColor }) => {
  const {
    selectedPropertyPhone,
    selectedPropertyName,
    currentStep,
    selectedPropertyId,
    selectedStartDate,
    selectedEndDate,
    totalPrice,
    setTotalPrice,
    selectedRoom,
    setSelectedRoom,
    selectedRooms,
    selectedRoomRate,
    getRoomNameById,
    selectedRoomDetails,
    setSelectedRoomDetails,
    cancellationPolicyState,
    addonList,
    setAddonList,
    isRoomsChange,
    selectedTaxList,
    setSelectedTaxList,
    rateResponse,
    setRateResponse,
    addOnsresponse,
    setAddOnsResponse,
    totalRoomPrice,
    setTotalRoomPrice,
    promoCodeContext,
    setPromoCodeContext,
    baseRoomPrice,
    setBaseRoomPrice,
    roomTaxes,
    setRoomTaxes,
    isAddOnns,
    setIsAddOnns,
    isMemberRate,
    setIsMemberRate,
    cancellationPolicyPackage,
    setCancellationPolicyPackage,
    isInventoryAvailable, setInventoryAvailable,
    totalTax, setTotalTax,
    isStayStepOpen, setIsStayStepOpen,
    totalRoomsBasePrice, setTotalRoomsBasePrice,
    nightFreePackageIds, setNightFreePackageIds,
    isRatePing, setRatePing,
    ratePingRoomId, setRatePingRoomId,
    ratePingPackageId, setRatePingPackageId,
    ratePingBasePrice, setRatePingBasePrice,
    ratePingTaxPrice, setRatePingTaxPrice,
      ratePingChainId, setRatePingChainId,
      ratePingChainName, setRatePingChainName,
      ratePingEndDate, setRatePingEndDate,
      ratePingStartDate, setRatePingStartDate,
    rateSearchPrice, setRateSearchPrice,
      ratePingTaxList,setRatePingTaxList,
      childAge, setChildAge,
      infantAge, setInfantAge,
    ghaUtmSource,setGhaUtmSource
  } = useBookingEngineContext();

  const dummyImage = "/no_image.jpg";
  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
  const totalAdults = selectedRooms.reduce((sum, room) => sum + room.adults, 0);
  const totalChildren = selectedRooms.reduce(
    (sum, room) => sum + room.children,
    0
  );
  const totalRooms = selectedRooms.length;
  const [selectedRoomId, setSelectedRoomId] = useState(null);
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const [isPropertyVisible, setIsPropertyVisible] = useState(false);
  const [isRoomsVisible, setIsRoomsVisible] = useState(false);
  const [isRoomsClose, setIsRoomsClose] = useState(false);
  const [taxList, setTaxList] = useState(null);
  const [isMaxCapacityExceeded, isMaxCapacityExceededSet] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cartDisplayMobile, setCartDisplayMobile] = useState(false);
  const roomsRef = useRef(null);

  const [isRateChange, setIsRateChange] = useState(false);
  const [aisOpen, setaIsOpen] = useState(false);
  const [aisOpen1, setaIsOpen1] = useState(false);
     const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const [isTaxCalculated, setIsTaxCalculated] = useState(false);
  const [filters, setFilters] = useState({
    offer: "",
    query: "",
    dateRange: { start: "", end: "", totalPrice: 0 },
    guests: { adults: 1, children: 0, rooms: 1 },
  });
  const formatDate = (date) => {
    if (!date) return ;
    else if (!isValidDate(date)) {
          return;
        }
    return new Date(date).toISOString().split("T")[0];
  };
function formatDateDMY(date) {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");       // 01, 02, ..., 31
  const month = String(d.getMonth() + 1).padStart(2, "0"); // 01, 02, ..., 12
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}
  const fromDate = formatDate(selectedStartDate);
  const toDate = formatDate(selectedEndDate);


 async function postBookingWidged(rooms,mapping, isClose,ctaName,
  ApiName,ApiUrl,ApiStatus,ApiErrorCode,ApiMessage) {
  const resp = await getUserInfo();

    const sessionId = sessionStorage?.getItem("sessionId");
  // if(!sessionId){
  //  setSessionId(resp?.guid);
  // }
    const totalAdults = selectedRoom?.reduce(
      (sum, room) => sum + (room?.adults || 0),
      0
    );
    const totalChildren = selectedRoom?.reduce(
      (sum, room) => sum + (room?.children || 0),
      0
    );
    const totalRooms = selectedRoom?.length;
    
    const ratePingPackage = (isRatePing && selectedRoom?.length === 1 && ratePingEndDate === 
      selectedEndDate && ratePingStartDate === selectedStartDate && ratePingBasePrice > 0) ? true : false;
      
    const payload = {
    ctaName: ctaName,
    urls: window.location.href,
    cityId: "0",
    propertyId: selectedPropertyId?.toString() ?? "0",
    checkIn: fromDate ?? "",
    checkOut: toDate ?? "",
    adults: totalAdults?.toString() ?? "0",
    children: totalChildren?.toString() ?? "0",
    rooms: totalRooms?.toString() ?? "0",
    promoCode: "",
    utm_source: ghaUtmSource ? ghaUtmSource : "",
    ip: resp?.ip,
    sessionId: sessionId,
    deviceName: resp?.deviceInfo?.deviceName,
    deviceType: resp?.deviceInfo?.deviceOS == "Unknown" ? resp?.deviceInfo?.platform : resp?.deviceInfo?.deviceOS,
    roomsName: rooms?.RoomName ?? selectedRoom?.map(room => room?.roomName)?.join(", "),
    packageName: mapping?.MappingName ?? selectedRoom?.map(room => room?.roomPackage)?.join(", "),
    isCartOpen: mapping?.MappingName ? "Y": "N",
    isCartEdit: "N",
    isCartClick: "N",
    isClose: isClose ? "Y" : "N",
    ApiName: ApiName ?? "",
    ApiUrl: ApiUrl ?? "",
    ApiStatus: ApiStatus?.toString() ?? "",
    ApiErrorCode: ApiErrorCode?.toString() ?? "",
    ApiMessage: ApiMessage ?? "",
    ChainName : (isRatePing && ratePingChainName) ? ratePingChainName : "",
    ChainId :  0,
    LowestRate : ratePingPackage ? parseFloat(ratePingBasePrice)?.toFixed(2) : 0.00,
    SearchRate : ratePingPackage ? parseFloat(rateSearchPrice)?.toFixed(2) 
     : Number(rooms?.minRate ?? 0.00).toFixed(2)
     // : 5000
   }
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_CMS_BASE_URL_CLARKS}/Api/tracker/BookingWidged`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify( payload ),
        }
      );
      // const res = await response?.json();
  }
  const calculateNumberOfDays = () => {
    if (!selectedStartDate || !selectedEndDate) return 1;
    const start = new Date(selectedStartDate);
    const end = new Date(selectedEndDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const numberOfDays = calculateNumberOfDays();
  // const calculateBasePrice = () => {
  //   // Sum all selectedRoom's roomRate
  //   const totalRoomRate = selectedRoom?.reduce(
  //     (sum, room) => sum + (parseFloat(room?.packageRate) || 0),
  //     0
  //   );
  //   return totalRoomRate * numberOfDays;
  // };
// const calculateBasePrice = () => {
//   return selectedRoom?.reduce((sum, room) => {
//     if (!room?.packageRateList) return sum;

//     const roomTotal = Object.values(room.packageRateList).reduce(
//       (roomSum, dateData) => {
//         const obp1 = dateData?.OBP?.[room?.adults?.toString()];
//         return roomSum + (obp1 ? parseFloat(obp1.RateBeforeTax || "0") : 0);
//       },
//       0
//     );

//     return sum + roomTotal;
//   }, 0);
// };

const calculateBasePrice = () => {
  return selectedRoom?.reduce((sum, room) => {
    if (!room?.packageRateList) return sum;

    const roomTotal = Object.values(room.packageRateList).reduce(
      (roomSum, dateData) => {
       // let obp1 = dateData?.OBP?.[room?.adults?.toString()];
        const obpObject = dateData?.OBP?.[0] || {};
    let obp1 = obpObject[String(room.adults)] || {};

        // fallback: last entry in OBP if specific adult key not found
        if (!obp1 && dateData?.OBP) {
          const keys = Object.keys(dateData.OBP).sort((a, b) => Number(a) - Number(b));
          const lastKey = keys[keys.length - 1];
          obp1 = dateData.OBP[parseInt(lastKey)];
        }

        return roomSum + (obp1 ? Math.round(parseFloat(obp1.RateBeforeTax || "0")) : 0);
      },
      0
    );

    return Math.round(sum + roomTotal);
  }, 0);
};
// const calculateTotalSavings = () => {
//   return selectedRoom?.reduce((sum, room) => {
//     if (!room?.packageRateList) return sum;

//     const savingsTotal = Object.values(room.packageRateList).reduce((roomSum, dateData) => {
//       let obp1 = dateData?.OBP?.[room?.adults?.toString()];

//       // fallback: last entry in OBP if specific adult key not found
//       if (!obp1 && dateData?.OBP) {
//         const keys = Object.keys(dateData.OBP).sort((a, b) => Number(a) - Number(b));
//         const lastKey = keys[keys.length - 1];
//         obp1 = dateData.OBP[parseInt(lastKey)];
//       }

//       return roomSum + (obp1 ? parseFloat(obp1.Savings || "0") : 0);
//     }, 0);

//     return sum + savingsTotal;
//   }, 0);
// };

const calculateTotalSavings = () => {
  return selectedRoom?.reduce((sum, room) => {
    if (!room?.savings) return sum;

    return sum + parseInt(room?.savings);
  }, 0);
};
  const calculateTotalWithTax = () => {
    const basePrice = calculateBasePrice();
    return totalTax + (basePrice || 0);
  };

  const basePrice = calculateBasePrice();
  const totalSavings = calculateTotalSavings();
  const finalAmount = calculateTotalWithTax();
  

  useEffect(()=>{
  setIsSmallScreen(window.innerWidth < 768);
  }, [window.innerWidth])
  const rateUpdate = async () => {
    
   // setIsTaxCalculated(false);
    const dayRate = rateResponse?.Rooms?.flatMap((room) => {
      const newSelectedRooms = selectedRoom.filter(
        (sel) => sel.roomId === room?.RoomId
      );

      return newSelectedRooms.map((selected) => {
        const matchedRatePlan = room?.RatePlans?.find(
          (ratePlan) => ratePlan?.RateId === selected?.rateId
        );

        const firstRateObj = matchedRatePlan
          ? Object.values(matchedRatePlan?.Rates || {})[0]
          : null;
          
        const rateList = matchedRatePlan
          ? matchedRatePlan?.Rates
          : null;

        const rateEntries = Array.isArray(rateList)
          ? rateList
          : rateList && typeof rateList === "object"
          ? Object.values(rateList)
          : [];
        const taxesFromRates = rateEntries.flatMap(dateData => {
        if (!dateData?.OBP) return [];

        // try adult-specific OBP
        let obp = dateData.OBP[selected.adults];

        // fallback: last available OBP entry
        if (!obp) {
          const keys = Object.keys(dateData.OBP).sort((a, b) => Number(a) - Number(b));
          const lastKey = keys[keys.length - 1];
          obp = dateData.OBP[parseInt(lastKey)];
        }
      
        return obp?.Tax || [];
      });
const { adults, children,childAges, applicableAdult, applicableChild, applicableGuest } = selected;

// Step 1: Adjust children to meet minimum adults
let adjustedAdults = adults;
let adjustedChildren = children;

let chargeableChildren = childAges.filter(
    age => Number(age) > infantAge
).length;

if (adults < applicableAdult && children > 0) {
  const neededAdults = applicableAdult - adults;
  const childrenToAdults = Math.min(neededAdults, children);
  adjustedAdults += childrenToAdults;
  adjustedChildren -= childrenToAdults;
}

 const adjustedChargeableChildren = Math.min(
       adjustedChildren,
       chargeableChildren
   );

// Step 2: Calculate extra children
// const extraChildren = 
//   adjustedChildren > applicableChild
//     ? Math.min(
//         adjustedChildren - applicableChild, // children beyond allowed
//         Math.max(0, adjustedAdults + adjustedChildren - applicableGuest) // total guests beyond allowed
//       )
//     : 0;

                const extraChildren =
                    adjustedChargeableChildren > applicableChild
                        ? Math.min(
                              adjustedChargeableChildren - applicableChild,
                              Math.max(
                                  0,
                                  adjustedAdults + adjustedChargeableChildren - applicableGuest
                              )
                          )
                        : 0;

  const rateListNew = matchedRatePlan?.Rates
  ? Object.entries(matchedRatePlan.Rates).reduce(
      (acc, [date, dateData]) => {
        // normalize OBP as array
        const obpArray = Array.isArray(dateData.OBP)
          ? dateData.OBP
          : [dateData.OBP];

        const obpWithCalculatedRates = obpArray.map((obpItem) => {
          const adultKey = (selected?.adults)?.toString();

          const rateAfterTax = Number(
            obpItem?.[adultKey]?.RateAfterTax || 0
          );

          return {
            ...obpItem,
            TotalRate: Math.round(rateAfterTax),
          };
        });

        acc[date] = {
          ...dateData,
          OBP: obpWithCalculatedRates,
        };

        return acc;
      },
      {}
    )
  : null;

        const extraChildTaxes = rateEntries.flatMap(dateData => {
        if (!dateData) return [];

        // try adult-specific OBP
        let obp1 = dateData.OBP[selected.adults];

        // fallback: last available OBP entry
        if (!obp1) {
          const keys = Object.keys(dateData.OBP).sort((a, b) => Number(a) - Number(b));
          const lastKey = keys[keys.length - 1];
          obp1 = dateData.OBP[parseInt(lastKey)];
        }
        // try adult-specific OBP
       // let obp = extraChildren >= 1 ? dateData?.ExtraChildRate?.Tax || [] : []
        let obp = [];

        // fallback: last available OBP entry
         if (extraChildren >= 1 && obp.length == 0) {
      //  const price = (parseFloat(dateData?.ExtraChildRate?.RateBeforeTax * parseInt(extraChildren)) + parseFloat(obp1.RateBeforeTax));
        
       // const effectivePrice = (parseFloat(dateData?.ExtraChildRate?.RateBeforeTax * parseInt(extraChildren)) + parseFloat(obp1.RateBeforeTax));
        
        const price = (parseFloat(dateData?.ExtraChildRate?.RateBeforeTax * parseInt(extraChildren)) + parseFloat(obp1.RateBeforeTax));
        const priceExtraChild = (parseFloat(dateData?.ExtraChildRate?.RateBeforeTax * parseInt(extraChildren)));
        //  obp = [ {
        //   "ID": "889723000000001",
        //   "Name": "GST",
        //   "Amount": price >= 7500 ? Math.round(price * 0.18) : Math.round(price * 0.05)
        //   }]
        
        //    obp = dateData?.ExtraChildRate?.Tax?.filter(
        //       tax => !tax?.Name?.toLowerCase().includes("gst")
        //     );
            
        //   const gstRate = effectivePrice >= 7500 ? 0.18 : 0.05;
        //   const gstAmount = Math.round(effectivePrice * gstRate);
          
        // let gsttax = {
        //   "ID": "889723000000001",
        //   "Name": "GST",
        //   "Amount": gstAmount
        //   }
          
        //  obp.push(gsttax)
        
      let gsttax = {
          "ID": "889723000000001",
          "Name": "GST",
          "Amount": price >= 7500 ? Math.round(priceExtraChild * 0.18) : Math.round(priceExtraChild * 0.05)
          }
         obp = dateData?.ExtraChildRate?.Tax;
         obp.push(gsttax)
         }
      
        return obp || [];
      });
        const packFromRates = rateEntries.flatMap(dateData => {
        if (!dateData?.OBP) return [];

        // try adult-specific OBP
        let obp = dateData.OBP[selected.adults];

        // fallback: last available OBP entry
        if (!obp) {
          const keys = Object.keys(dateData.OBP).sort((a, b) => Number(a) - Number(b));
          const lastKey = keys[keys.length - 1];
          obp = dateData.OBP[parseInt(lastKey)];
        }
      
        return obp;
      })
          const primary = packFromRates?.[room?.adults?.toString()]?.RateAfterTax ?? undefined;

        // fallback = last rate in rates object/array
        let fallback = 0;
        if (packFromRates) {
          if (Array.isArray(packFromRates)) {
            // If rates is an array
            const last = packFromRates[packFromRates.length - 1];
            fallback = last?.RateAfterTax ?? 0;
          } else {
            // If rates is an object with numeric keys as strings
            const keys = Object.keys(packFromRates).sort((a, b) => Number(a) - Number(b));
            const lastKey = keys[keys.length - 1];
            fallback = packFromRates[lastKey]?.RateAfterTax ?? 0;
          }
        }

          const primaryBe = packFromRates?.[room?.adults?.toString()]?.RateBeforeTax ?? undefined;

        // fallback = last rate in rates object/array
        let fallbackBe = 0;
        if (packFromRates) {
          if (Array.isArray(packFromRates)) {
            // If rates is an array
            const last = packFromRates[packFromRates.length - 1];
            
            const isNightFree = nightFreePackageIds.some(
              (item) =>
                item.propertyId == selectedPropertyId &&
                item.packageId == selected?.rateId
            );

            if (
              isNightFree &&
              (!last?.RateBeforeTax || last?.RateBeforeTax == "0.00" || last?.RateBeforeTax == "0")
            ) {
              last = packFromRates[0];
            }
            
            fallbackBe = last?.RateBeforeTax ?? 0;
          } else {
            // If rates is an object with numeric keys as strings
            const keys = Object.keys(packFromRates).sort((a, b) => Number(a) - Number(b));
            const lastKey = keys[keys.length - 1];
            fallbackBe = packFromRates[lastKey]?.RateBeforeTax ?? 0;
          }
        }
        setSelectedRoom((prev) =>
          prev.map((rm) =>
            rm?.adults <= selected.maxAdult &&
            rm?.rateId === selected?.rateId &&
            rm?.roomId === selected?.roomId
              ? {
                  ...rm,
                  packageRate:
                    primaryBe ?? fallbackBe,
                  roomRateWithTax:
                    primary ?? fallback,
                  adultRate:
                    parseFloat(firstRateObj?.ExtraAdultRate?.RateAfterTax) ||
                    0.0,
                  childRate:
                    parseFloat(firstRateObj?.ExtraChildRate?.RateAfterTax) ||
                    0.0,
                  roomAdultExtraCharge:
                    parseInt(
                      firstRateObj?.OBP?.[rm.adults.toString()]?.RateAfterTax
                    ) - parseInt(firstRateObj?.OBP?.["1"]?.RateAfterTax),
                  //packageRateList: rateList,
                     packageRateList: rateListNew 
                }
              : rm
          )
        );
    //     ];
    
        if(extraChildTaxes.length > 0){
          const taxArray = [
          ...taxesFromRates,
          ...extraChildTaxes,
        ];
        const taxObject = {};
        taxArray.forEach((t) => {
          if (t?.Name && t?.Amount != null) {
            const amount = parseFloat(t.Amount);
            taxObject[t.Name] = (taxObject[t.Name] || 0) + amount;
          }
        });

        if (firstRateObj && selected) {
          if (extraChildren > 0) {            
          //   const totalExtraChildRate = rateEntries.reduce((sum, dateData) => {
          //     const rate = parseFloat(dateData?.ExtraChildRate?.RateBeforeTax || "0");
          //     return sum + rate;
          //   }, 0);
          // taxObject["ExtraChildRate"] = Math.round(totalExtraChildRate) * extraChildren;
          
            const totalExtraChildRate = rateEntries.reduce((sum, dateData) => {
              const rate = parseFloat(dateData?.ExtraChildRate?.RateBeforeTax || "0");
              return sum + rate;
            }, 0);
            
            const totalExtraChildSaving = rateEntries.reduce((sum, dateData) => {
              const rate = parseFloat(dateData?.ExtraChildRate?.Savings || "0");
              return sum + rate;
            }, 0);

          taxObject["ExtraChildRate"] = Math.round(totalExtraChildRate) * extraChildren;
          taxObject["ExtraChildSaving"] = Math.round(totalExtraChildSaving)* extraChildren;
          }

          if (
            selected?.adults > selected?.maxAdult &&
            parseFloat(firstRateObj?.ExtraAdultRate?.RateAfterTax) > 1.0
          ) {
            taxObject["ExtraAdultRate"] = parseFloat(
              firstRateObj?.ExtraAdultRate?.RateBeforeTax || 0.0
            );
          }
          // if (isMemberRate) {
          //   taxObject["GST2"] = Math.round(
          //     selected?.packageRate *
          //       (selected?.packageRate <= 7500 ? 0.12 : 0.18)
          //   );
          // }
        }
        return {
          RoomId: selected?.roomId,
          RateId: selected?.rateId,
          MinInventory: room?.MinInventory,
          RateAfterTax: parseInt(firstRateObj?.OBP?.["1"]?.RateAfterTax || "0"),
          ...taxObject,
        };
        }
        else{
          
          const taxArray = [
         ...taxesFromRates,
          ...extraChildTaxes,
        ];
        const taxObject = {};
        taxArray.forEach((t) => {
          if (t?.Name && t?.Amount != null) {
            const amount = parseFloat(t.Amount);
            taxObject[t.Name] = (taxObject[t.Name] || 0) + amount;
          }
        });

        if (firstRateObj && selected) {
          if (extraChildren > 0) {
            
          //   const totalExtraChildRate = rateEntries.reduce((sum, dateData) => {
          //     const rate = parseFloat(dateData?.ExtraChildRate?.RateBeforeTax || "0");
          //     return sum + rate;
          //   }, 0);
          // taxObject["ExtraChildRate"] = Math.round(totalExtraChildRate) * extraChildren;
          
            const totalExtraChildRate = rateEntries.reduce((sum, dateData) => {
              const rate = parseFloat(dateData?.ExtraChildRate?.RateBeforeTax || "0");
              return sum + rate;
            }, 0);

            const totalExtraChildSaving = rateEntries.reduce((sum, dateData) => {
              const rate = parseFloat(dateData?.ExtraChildRate?.Savings || "0");
              return sum + rate;
            }, 0);

          taxObject["ExtraChildRate"] = Math.round(totalExtraChildRate) * extraChildren;
          taxObject["ExtraChildSaving"] = Math.round(totalExtraChildSaving)* extraChildren;
          }

          if (
            selected?.adults > selected?.maxAdult &&
            parseFloat(firstRateObj?.ExtraAdultRate?.RateAfterTax) > 1.0
          ) {
            taxObject["ExtraAdultRate"] = parseFloat(
              firstRateObj?.ExtraAdultRate?.RateBeforeTax || 0.0
            );
          }
          // if (isMemberRate) {
          //   taxObject["GST2"] = Math.round(
          //     selected?.packageRate *
          //       (selected?.packageRate <= 7500 ? 0.12 : 0.18)
          //   );
          // }
        }
        return {
          RoomId: selected?.roomId,
          RateId: selected?.rateId,
          MinInventory: room?.MinInventory,
          RateAfterTax: parseInt(firstRateObj?.OBP?.["1"]?.RateAfterTax || "0"),
          ...taxObject,
        };
        }
      });
    });

    return dayRate;
  };

  const fetchRateApi = async () => {
    // const response = await axios.post("/api/staah-api/rate", {
    //   selectedPropertyId,
    //   fromDate,
    //   toDate,
    // });

  //setIsTaxCalculated(false);
  let roomsData = "";
  let mappingData ="";
  let isCloseData = false;
  let apiStatusData = "";
  let apiErrorCodeData = "";
  let apiMessageData = "";
  let ctaNameData = "Fetch Rate";
  let apiNameData = "rate";
  let apiUrlData = `${process.env.NEXT_PUBLIC_STAAH_BASE_URL}/api/cin-api/rate`;
  postBookingWidged(roomsData,mappingData, isCloseData,ctaNameData,
      apiNameData,apiUrlData,apiStatusData,apiErrorCodeData,apiMessageData);

  try {
     const guid = crypto.randomUUID();
    const timestamp = Date.now().toString();
    const secret = "ABDEFGHJKLMOPQRSTUVWXYZ123456789";

    const signature = await createSignature(
      JSON.stringify(selectedPropertyId),
      timestamp,
      secret
    );

    const body = {
      selectedPropertyId: selectedPropertyId,
      fromDate,
      toDate,
      guId:guid,
      promoCodeContext 
      // product: "No",
    };
  //  if(promoCode != "" || new Date(fromDate) > cutoffDate)
    // if(promoCode == "")
    // {
      const response = await fetch(`${process.env.NEXT_PUBLIC_STAAH_BASE_URL}/api/cin-api/inventory`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-timestamp": timestamp,
        "x-signature": signature,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
   // setIsRateFetched(true);
      apiStatusData= response?.status;
      apiErrorCodeData= response?.status;
      apiMessageData= "Data not found";
    }

    const data = await response.json();

      const product = Array.isArray(data?.Product) ? data?.Product[0] : null;
      if(!product){
      apiStatusData= data?.message;
      apiErrorCodeData= data?.TrackingID;
      apiMessageData= data?.message;;
      }
     // const rooms = product?.Rooms || [];
    const dayRate = product?.Rooms?.flatMap((room) => {
      const newSelectedRooms = selectedRoom.filter(
        (sel) => sel.roomId === room?.RoomId
      );

      return newSelectedRooms.map((selected) => {
        const matchedRatePlan = room?.RatePlans?.find(
          (ratePlan) => ratePlan?.RateId === selected?.rateId
        );
      if(!matchedRatePlan){

      apiStatusData= "No Rate Plans";
      apiErrorCodeData= "No Rate Plans";;
      apiMessageData= "Success";
      }
        const firstRateObj = matchedRatePlan ? Object.values(matchedRatePlan?.Rates || {})[0] : null;

        //const rateList = matchedRatePlan ? matchedRatePlan?.Rates : null;

        const rateList = matchedRatePlan
          ? matchedRatePlan?.Rates
          : null;

        const rateEntries = Array.isArray(rateList)
          ? rateList
          : rateList && typeof rateList === "object"
          ? Object.values(rateList)
          : [];
          
        
        const taxesFromRates = rateEntries.flatMap(dateData => {
        if (!dateData?.OBP) return [];

        // try adult-specific OBP
        let obp = dateData.OBP[selected.adults];

        // fallback: last available OBP entry
        if (!obp) {
          const keys = Object.keys(dateData.OBP).sort((a, b) => Number(a) - Number(b));
          const lastKey = keys[keys.length - 1];
          obp = dateData.OBP[parseInt(lastKey)];
        }
      
        return obp?.Tax || [];
      });

        const { adults, children, childAges, applicableAdult, applicableChild, applicableGuest } = selected;

// Step 1: Adjust children to meet minimum adults
let adjustedAdults = adults;
let adjustedChildren = children;

let chargeableChildren = childAges.filter(
    age => Number(age) > infantAge
).length;

if (adults < applicableAdult && children > 0) {
  const neededAdults = applicableAdult - adults;
  const childrenToAdults = Math.min(neededAdults, children);
  adjustedAdults += childrenToAdults;
  adjustedChildren -= childrenToAdults;
}

// Step 2: Calculate extra children
// const extraChildren = 
//   adjustedChildren > applicableChild
//     ? Math.min(
//         adjustedChildren - applicableChild, // children beyond allowed
//         Math.max(0, adjustedAdults + adjustedChildren - applicableGuest) // total guests beyond allowed
//       )
//     : 0;

 const adjustedChargeableChildren = Math.min(
       adjustedChildren,
       chargeableChildren
   );


        const extraChildren =
            adjustedChargeableChildren > applicableChild
                ? Math.min(
                      adjustedChargeableChildren - applicableChild,
                      Math.max(
                          0,
                          adjustedAdults + adjustedChargeableChildren - applicableGuest
                      )
                  )
                : 0;

  const rateListNew = matchedRatePlan?.Rates
  ? Object.entries(matchedRatePlan.Rates).reduce(
      (acc, [date, dateData]) => {
        // normalize OBP as array
        const obpArray = Array.isArray(dateData.OBP)
          ? dateData.OBP
          : [dateData.OBP];

        const obpWithCalculatedRates = obpArray.map((obpItem) => {
          const adultKey = (selected?.adults)?.toString();

          const rateAfterTax = Number(
            obpItem?.[adultKey]?.RateAfterTax || 0
          );
          return {
            ...obpItem,
            TotalRate: Math.round(rateAfterTax),
          };
        });

        acc[date] = {
          ...dateData,
          OBP: obpWithCalculatedRates,
        };

        return acc;
      },
      {}
    )
  : null;
        const extraChildTaxes = rateEntries.flatMap(dateData => {
        if (!dateData) return [];

        // try adult-specific OBP
        let obp1 = dateData.OBP[selected.adults];

        // fallback: last available OBP entry
        if (!obp1) {
          const keys = Object.keys(dateData.OBP).sort((a, b) => Number(a) - Number(b));
          const lastKey = keys[keys.length - 1];
          obp1 = dateData.OBP[parseInt(lastKey)];
        }
        // try adult-specific OBP
        
       // let obp = extraChildren >= 1 ? dateData?.ExtraChildRate?.Tax || [] : []
        let obp = [];

        // fallback: last available OBP entry
         if (extraChildren >= 1 && obp.length == 0) {
        //  obp =[ {
        //   "ID": "889723000000001",
        //   "Name": "GST",
        //   "Amount": dateData?.ExtraChildRate?.RateBeforeTax * 0.05
        //   // "Amount": Math.round((dateData?.ExtraChildRate?.RateBeforeTax || "0") * 0.05)
        //   }]
        //const price = (parseFloat(dateData?.ExtraChildRate?.RateBeforeTax * parseInt(extraChildren)) + parseFloat(obp1.RateBeforeTax));
        
       // const effectivePrice = (parseFloat(dateData?.ExtraChildRate?.RateBeforeTax * parseInt(extraChildren)) + parseFloat(obp1.RateBeforeTax));
        
        const price = (parseFloat(dateData?.ExtraChildRate?.RateBeforeTax * parseInt(extraChildren)) + parseFloat(obp1.RateBeforeTax));
        const priceExtraChild = (parseFloat(dateData?.ExtraChildRate?.RateBeforeTax * parseInt(extraChildren)));
        
        //  obp = [ {
        //   "ID": "889723000000001",
        //   "Name": "GST",
        //   "Amount": price >= 7500 ? Math.round(price * 0.18) : Math.round(price * 0.05)
        //   }]
        
      // obp = dateData?.ExtraChildRate?.Tax?.filter(
      //         tax => !tax?.Name?.toLowerCase().includes("gst")
      //       );
            
      // const gstRate = effectivePrice >= 7500 ? 0.18 : 0.05;
      // const gstAmount = Math.round(effectivePrice * gstRate);
      //   let gsttax = {
      //     "ID": "889723000000001",
      //     "Name": "GST",
      //     "Amount": gstAmount
      //     }
          
      //    obp.push(gsttax)
      
      let gsttax = {
          "ID": "889723000000001",
          "Name": "GST",
          "Amount": price >= 7500 ? Math.round(priceExtraChild * 0.18) : Math.round(priceExtraChild * 0.05)
          }
         obp = dateData?.ExtraChildRate?.Tax;
         obp.push(gsttax)
         }
      
        return obp || [];
      });

        const packFromRates = rateEntries.flatMap(dateData => {
        if (!dateData?.OBP) return [];

        // try adult-specific OBP
        let obp = dateData.OBP[selected.adults];

        // fallback: last available OBP entry
        if (!obp) {
          const keys = Object.keys(dateData.OBP).sort((a, b) => Number(a) - Number(b));
          const lastKey = keys[keys.length - 1];
          obp = dateData.OBP[parseInt(lastKey)];
        }
      
        return obp;
      });

          const primary = packFromRates?.[room?.adults?.toString()]?.RateAfterTax ?? undefined;

        // fallback = last rate in rates object/array
        let fallback = 0;
        if (packFromRates) {
          if (Array.isArray(packFromRates)) {
            // If rates is an array
            const last = packFromRates[packFromRates.length - 1];
            fallback = last?.RateAfterTax ?? 0;
          } else {
            // If rates is an object with numeric keys as strings
            const keys = Object.keys(packFromRates).sort((a, b) => Number(a) - Number(b));
            const lastKey = keys[keys.length - 1];
            fallback = packFromRates[lastKey]?.RateAfterTax ?? 0;
          }
        }

          const primaryBe = packFromRates?.[room?.adults?.toString()]?.RateBeforeTax ?? undefined;

        // fallback = last rate in rates object/array
        let fallbackBe = 0;
        if (packFromRates) {
          if (Array.isArray(packFromRates)) {
            // If rates is an array
            const last = packFromRates[packFromRates.length - 1];
                   
            const isNightFree = nightFreePackageIds.some(
              (item) =>
                item.propertyId == selectedPropertyId &&
                item.packageId == selected?.rateId
            );
            
            if (
              isNightFree &&
              (!last?.RateBeforeTax || last?.RateBeforeTax == "0.00" || last?.RateBeforeTax == "0")
            ) {
              last = packFromRates[0];
            }
            
            fallbackBe = last?.RateBeforeTax ?? 0;
          } else {
            // If rates is an object with numeric keys as strings
            const keys = Object.keys(packFromRates).sort((a, b) => Number(a) - Number(b));
            const lastKey = keys[keys.length - 1];
            fallbackBe = packFromRates[lastKey]?.RateBeforeTax ?? 0;
          }
        }
        // Update packageRate for selectedRoom
        setSelectedRoom((prev) =>
          prev.map((rm) =>
            rm?.adults <= selected.maxAdult &&
            rm?.rateId === selected?.rateId &&
            rm?.roomId === selected?.roomId
              ? {
                  ...rm,
                  packageRate: Math.round(
                        parseFloat(primaryBe ?? fallbackBe) || 0
                      ),
                  packageRateList: rateListNew,
                  roomRateWithTax: isMemberRate
                    ? Math.round(
                        firstRateObj?.OBP?.[rm?.adults?.toString()]?.RateBeforeTax
                      ) +
                      Math.round(
                        Math.round(
                          firstRateObj?.OBP?.[rm?.adults?.toString()]
                            ?.RateBeforeTax
                        ) *
                          (Math.round(
                            firstRateObj?.OBP?.[rm?.adults?.toString()]
                              ?.RateBeforeTax
                          ) <= 7500
                            ? 1.2
                            : 1.8)
                      )
                    : Math.round(
                       // firstRateObj?.OBP?.[rm?.adults?.toString()]?.RateAfterTax
                       
                        primary ??
                        fallback
                      ),
                  adultRate:
                    parseFloat(firstRateObj?.ExtraAdultRate?.RateAfterTax) ||
                    0.0,
                  childRate:
                    parseFloat(firstRateObj?.ExtraChildRate?.RateAfterTax) ||
                    0.0,
                  roomAdultExtraCharge:
                    parseInt(
                      firstRateObj?.OBP?.[rm?.adults?.toString()]?.RateAfterTax
                    ) - parseInt(firstRateObj?.OBP?.["1"]?.RateAfterTax),
                     packageRateList: rateListNew 
                }
              : rm
          )
        );

        if(extraChildTaxes.length > 0){
          const taxArray = [
          ...taxesFromRates,
          ...extraChildTaxes,
        ];
        const taxObject = {};
        taxArray.forEach((t) => {
          if (t?.Name && t?.Amount != null) {
            const amount = parseFloat(t.Amount);
            taxObject[t.Name] = (taxObject[t.Name] || 0) + amount;
          }
        });

        if (firstRateObj && selected) {
          if (extraChildren > 0) {            
          //   const totalExtraChildRate = rateEntries.reduce((sum, dateData) => {
          //     const rate = parseFloat(dateData?.ExtraChildRate?.RateBeforeTax || "0");
          //     return sum + rate;
          //   }, 0);
          // taxObject["ExtraChildRate"] = Math.round(totalExtraChildRate) * extraChildren;
            const totalExtraChildRate = rateEntries.reduce((sum, dateData) => {
              const rate = parseFloat(dateData?.ExtraChildRate?.RateBeforeTax || "0");
              return sum + rate;
            }, 0);

            const totalExtraChildSaving = rateEntries.reduce((sum, dateData) => {
              const rate = parseFloat(dateData?.ExtraChildRate?.Savings || "0");
              return sum + rate;
            }, 0);
          taxObject["ExtraChildRate"] = Math.round(totalExtraChildRate) * extraChildren;
          taxObject["ExtraChildSaving"] = Math.round(totalExtraChildSaving)* extraChildren;
          }

          if (
            selected?.adults > selected?.maxAdult &&
            parseFloat(firstRateObj?.ExtraAdultRate?.RateAfterTax) > 1.0
          ) {
            taxObject["ExtraAdultRate"] = parseFloat(
              firstRateObj?.ExtraAdultRate?.RateBeforeTax || 0.0
            );
          }
          // if (isMemberRate) {
          //   taxObject["GST2"] = Math.round(
          //     selected?.packageRate *
          //       (selected?.packageRate <= 7500 ? 0.12 : 0.18)
          //   );
          // }
        }
        return {
          RoomId: selected?.roomId,
          RateId: selected?.rateId,
          MinInventory: room?.MinInventory,
          RateAfterTax: parseInt(firstRateObj?.OBP?.["1"]?.RateAfterTax || "0"),
          ...taxObject,
        };
        }
        else{
          
          const taxArray = [
         ...taxesFromRates,
          ...extraChildTaxes,
        ];
        const taxObject = {};
        taxArray.forEach((t) => {
          if (t?.Name && t?.Amount != null) {
            const amount = parseFloat(t.Amount);
            taxObject[t.Name] = (taxObject[t.Name] || 0) + amount;
          }
        });

        if (firstRateObj && selected) {
          if (extraChildren > 0) {
            
          //   const totalExtraChildRate = rateEntries.reduce((sum, dateData) => {
          //     const rate = parseFloat(dateData?.ExtraChildRate?.RateBeforeTax || "0");
          //     return sum + rate;
          //   }, 0);
          // taxObject["ExtraChildRate"] = Math.round(totalExtraChildRate)* extraChildren;
            const totalExtraChildRate = rateEntries.reduce((sum, dateData) => {
              const rate = parseFloat(dateData?.ExtraChildRate?.RateBeforeTax || "0");
              return sum + rate;
            }, 0);

            const totalExtraChildSaving = rateEntries.reduce((sum, dateData) => {
              const rate = parseFloat(dateData?.ExtraChildRate?.Savings || "0");
              return sum + rate;
            }, 0);
          taxObject["ExtraChildRate"] = Math.round(totalExtraChildRate)* extraChildren;
          taxObject["ExtraChildSaving"] = Math.round(totalExtraChildSaving)* extraChildren;
          }

          if (
            selected?.adults > selected?.maxAdult &&
            parseFloat(firstRateObj?.ExtraAdultRate?.RateAfterTax) > 1.0
          ) {
            taxObject["ExtraAdultRate"] = parseFloat(
              firstRateObj?.ExtraAdultRate?.RateBeforeTax || 0.0
            );
          }
          // if (isMemberRate) {
          //   taxObject["GST2"] = Math.round(
          //     selected?.packageRate *
          //       (selected?.packageRate <= 7500 ? 0.12 : 0.18)
          //   );
          // }
        }
        return {
          RoomId: selected?.roomId,
          RateId: selected?.rateId,
          MinInventory: room?.MinInventory,
          RateAfterTax: parseInt(firstRateObj?.OBP?.["1"]?.RateAfterTax || "0"),
          ...taxObject,
        };
        }
      });
    });

      apiStatusData= response?.status;
      apiErrorCodeData= response?.status;
      apiMessageData= "Success";
    return dayRate;
  }catch(error){
       apiStatusData= error?.message;
       apiErrorCodeData= "1166";
       apiMessageData= error?.message;
  }finally {
   // postBookingWidged("","", false,"rate Fetched","rate","https://cindemo.cinuniverse.com/api/cin-api/rate",);
      setTimeout(() => {
      postBookingWidged(roomsData,mappingData, isCloseData,"rate Fetched",
      apiNameData,apiUrlData,apiStatusData,apiErrorCodeData,apiMessageData);
    }, 200);

    }
  };

  useEffect(() => {
    for (let i = 0; i < selectedRoom?.length; i++) {
      if (
        parseInt(selectedRoom?.[i]?.adults) + parseInt(selectedRoom?.[i]?.children) >
        selectedRoom?.[i]?.maxGuest
      ) {
        isMaxCapacityExceededSet(true);
      } else {
        isMaxCapacityExceededSet(false);
      }
    }
    setIsRateChange(true);
  }, [selectedRoom]);
 

      useEffect(() => {
        if (finalAmount !== null && !isNaN(finalAmount) && isStayStepOpen) {
          const fetchPrices = async () => {
            if (!selectedPropertyId && currentStep !== 0) return;
            setIsStayStepOpen(false);
            try {
              const response = await rateUpdate();

              if (selectedRoom?.length > 0) {
                
                const updatedRooms = selectedRoom?.map((sel, indx) => {
                  // Get all matches (could be 2: one with, one without ExtraChildRate)
                  const matchedRates = response?.filter(
                    (rate) => rate?.RateId === sel?.rateId && rate?.RoomId === sel?.roomId
                  );
                
                  if (!matchedRates?.length) return null;
                
                  // Pick based on whether the room has children or not
                  let matchedRate;
                  let matchedExtraChildSaving;
                
                  if(matchedRates?.length > 1){
                    if (sel.children > 0) {
                    // Prefer one that has ExtraChildRate
                    matchedRate =
                     // matchedRates.find((r) => "ExtraChildRate" in r) ||  matchedRates[indx];
                      matchedRates.find((r) => "ExtraChildRate" in r) || matchedRates[matchedRates?.length - 1];
                      
                    matchedExtraChildSaving =
                      matchedRates.find((r) => "ExtraChildSaving" in r) || matchedRates[matchedRates?.length - 1];
                  } else {
                    // Prefer one that does NOT have ExtraChildRate
                   // matchedRate = matchedRates[indx];
                    matchedRate = matchedRates[matchedRates?.length - 1];
                  }
                }else{
                if (sel.children > 0) {
                    // Prefer one that has ExtraChildRate
                    matchedRate =
                      matchedRates.find((r) => "ExtraChildRate" in r) ||  matchedRates[0];

                    matchedExtraChildSaving =
                      matchedRates.find((r) => "ExtraChildSaving" in r) || matchedRates[0];
                  } else {
                    // Prefer one that does NOT have ExtraChildRate
                    matchedRate = matchedRates[0];
                  }
                  }
                
                  let finalRate = { ...matchedRate }; // avoid mutating original
                  return { ...finalRate, Id: sel?.id };
                });

                const allTaxKeys = new Set();
                let hasZeroInventory = false;

                updatedRooms?.forEach((room) => {
                  if (!room) return;

                  if (room?.MinInventory === 0) {
                    hasZeroInventory = true;
                    return;
                  }

                  Object.keys(room).forEach((key) => {
                    if (
                      ![
                        "roomId",
                        "RateId",
                        "MinInventory",
                        "RateAfterTax",
                        "Id",
                        "ExtraChildSaving",
                      ].includes(key) &&
                      typeof room[key] === "number"
                    ) {
                      allTaxKeys.add(key);
                    }
                  });
                });

                if (hasZeroInventory) {
                  setInventoryAvailable(false);
                } else {
                  setInventoryAvailable(true);
                }
                setRoomTaxes(updatedRooms);
                const taxList = {};
                allTaxKeys.forEach((key) => {
                  taxList[key] = updatedRooms
                    .filter((room) => room !== undefined && room !== null)
                    .reduce(
                      (acc, room) => acc + (room[key] || 0),
                      0
                    );
                });

                setTaxList(taxList);
                setSelectedTaxList(taxList);

                const totalTax = Object.values(taxList).reduce(
                  (acc, taxVal) => acc + taxVal,
                  0
                );
                setTotalTax(totalTax);
                setIsTaxCalculated(true);
              }
            } catch (error) {
              console.error("Error fetching prices:", error);
            }
          };

          fetchPrices();
          setTotalPrice(finalAmount);
        //  if(selectedRoomDetails?.isPropertyVisible == true)
      //  {

      //  setTotalRoomsBasePrice(basePrice);
      //  }
    
       setTotalRoomsBasePrice(basePrice);
        }
      }, [
        // finalAmount,
        isRoomsChange,
        currentStep,
        isStayStepOpen
    //  selectedStartDate,
    //  selectedEndDate,
      ]);

   useEffect(() => {
     if (finalAmount !== null && !isNaN(finalAmount) && !isStayStepOpen) {
       const fetchPrices = async () => {
         if (!selectedPropertyId && currentStep !== 0) return;

         try {
           const response = await fetchRateApi();

           if (selectedRoom?.length > 0) {
           
            const updatedRooms = selectedRoom?.map((sel, indx) => {
              // Get all matches (could be 2: one with, one without ExtraChildRate)
              const matchedRates = response?.filter(
                (rate) => rate?.RateId === sel?.rateId && rate?.RoomId === sel?.roomId
              );
            
              if (!matchedRates?.length) return null;
            
              // Pick based on whether the room has children or not
              let matchedRate;
            
              
                  if(matchedRates?.length > 1){
                    if (sel.children > 0) {
                    // Prefer one that has ExtraChildRate
                    matchedRate =
                     // matchedRates.find((r) => "ExtraChildRate" in r) ||  matchedRates[indx];
                      matchedRates.find((r) => "ExtraChildRate" in r) || matchedRates[matchedRates?.length - 1];
                  } else {
                    // Prefer one that does NOT have ExtraChildRate
                   // matchedRate = matchedRates[indx];
                    matchedRate = matchedRates[matchedRates?.length - 1];
                  }
                }else{
                if (sel.children > 0) {
                    // Prefer one that has ExtraChildRate
                    matchedRate =
                      matchedRates.find((r) => "ExtraChildRate" in r) ||  matchedRates[0];
                  } else {
                    // Prefer one that does NOT have ExtraChildRate
                    matchedRate = matchedRates[0];
                  }
                  }
            
               let finalRate = { ...matchedRate }; // avoid mutating original
              return { ...finalRate, Id: sel?.id };
            });

             const allTaxKeys = new Set();
             let hasZeroInventory = false;

             updatedRooms?.forEach((room) => {
               if (!room) return;

               if (room?.MinInventory === 0) {
                 hasZeroInventory = true;
                 return;
               }

               Object.keys(room).forEach((key) => {
                 if (
                   ![
                     "roomId",
                     "RateId",
                     "MinInventory",
                     "RateAfterTax",
                     "Id",
                     "ExtraChildSaving",
                   ].includes(key) &&
                   typeof room[key] === "number"
                 ) {
                   allTaxKeys.add(key);
                 }
               });
             });

             if (hasZeroInventory) {
               setInventoryAvailable(false);
             } else {
               setInventoryAvailable(true);
             }
             setRoomTaxes(updatedRooms);
             const taxList = {};
            //  allTaxKeys.forEach((key) => {
            //    const actualKey = isMemberRate && key === "GST" ? "GST2" : key;

            //    taxList[key] = updatedRooms
            //      .filter((room) => room !== undefined && room !== null)
            //      .reduce((acc, room) => {
            //        return acc + (room[actualKey] || 0);
            //      }, 0);
            //  });
                       
                allTaxKeys.forEach((key) => {
                  taxList[key] = updatedRooms
                    .filter((room) => room !== undefined && room !== null)
                    .reduce(
                      (acc, room) => acc + (room[key] || 0),
                      0
                    );
                });
             setTaxList(taxList);
             setSelectedTaxList(taxList);

             const totalTax = Object.values(taxList).reduce(
               (acc, taxVal) => acc + taxVal,
               0
             );
             setTotalTax(totalTax);
             setIsTaxCalculated(true);
           }
         } catch (error) {
           console.error("Error fetching prices:", error);
         }
       };

       fetchPrices();
       setTotalPrice(finalAmount);
      //  if(selectedRoomDetails?.isPropertyVisible == true)
      //  {

      //  setTotalRoomsBasePrice(basePrice);
      //  }
    
       setTotalRoomsBasePrice(basePrice);
     }
   }, [
       finalAmount,
      // isRoomsChange,
      // currentStep,
     selectedStartDate,
     selectedEndDate,
   ]);

  const openPropertyPage = (id) => {
    setSelectedRoomDetails({ isPropertyVisible: false, id: id });
    setSelectedRoomId(id);
    setIsPropertyVisible(true);
  };
  const removeProperty = (id) => {
    setSelectedRoom((prev) =>
      prev.map((room) =>
        room.id === id
          ? {
              ...room,
              roomId: "",
              roomName: "",
              roomRate: "",
              roomImage: null,
              packageRate: "",
              childRate: "",
            } // Use null instead of {}
          : room
      )
    );
  };
  const openDatePickerPage = () => {
    setIsDatePickerVisible(!isDatePickerVisible);
  };
  const openRoomPage = () => {

    setIsRoomsClose(!isRoomsClose);
    setIsRoomsVisible(!isRoomsVisible);
  };

useEffect(() => {
    const handleClickOutside = (event) => {
      if (roomsRef.current && !roomsRef.current.contains(event.target)) {
        setIsRoomsVisible(false);
      }
    };

    if (isRoomsVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isRoomsVisible]);

  const handleRoomChange = () => {
   // setIsRoomsVisible(!isRoomsVisible);
    
     setCartDisplayMobile(true);
    // setFilters((prev) => ({
    //   ...prev,
    //   //guests: { adults, children, rooms: roomCount },
    // }));
  };

  const proceedAddOn = (selectedRoom) => {
    const isProceed = selectedRoom.every((room) => room.roomId);

    // Check if any room has more guests than allowed
    const isGuestLimitExceeded = selectedRoom.some(
      (room) => room.adults + room.children > room.maxGuest
    );
    const isAdultLimitExceeded = selectedRoom.some(
      (room) => room.adults > room.maxAdult
    );

    const isChildLimitExceeded = selectedRoom.some(
      (room) => room.children > room.maxChildren
    );
    if (
      isProceed &&
      !isGuestLimitExceeded &&
      isInventoryAvailable &&
      !isAdultLimitExceeded &&
      !isChildLimitExceeded
    ) {
      setTotalRoomPrice(finalAmount);
      setBaseRoomPrice(basePrice);
      //  if(selectedRoomDetails?.isPropertyVisible == true)
      //  {

      //  setTotalRoomsBasePrice(basePrice);
      //  }
    
       setTotalRoomsBasePrice(basePrice);
      goNext();
    } else if (!isProceed) {
      toast.error("Select your room(s)");
    } else if (isGuestLimitExceeded) {
      toast.error(
        "Selected guests are greater than the max guest allowed in one or more rooms"
      );
    } else if (isAdultLimitExceeded) {
      toast.error(
        "Selected adults are greater than the max adults allowed in one or more rooms"
      );
    } else if (isChildLimitExceeded) {
      toast.error(
        "Selected children are greater than the max children allowed in one or more rooms"
      );
    } else if (!isInventoryAvailable) {
      toast.error("Booking not available for selected date");
    }
  };

  return (
    <>
     <Toaster position="top-right" />
      <div className="stay-info">
        <div className="wizard-step-global-padding right-card-data">
            <div className="pl-2">
              <h4 className="wizard-title-main cart-display-mobile" onClick={()=>setCartDisplayMobile(!cartDisplayMobile)}>
                <span className="d-flex w-100 justify-content-between align-items-center">
                 Booking Details { Math.round(totalSavings) > 0 &&  <strong className="amount-in-wizard total-amount-cart text-success"> {" - You Saved INR " } {Math.round(totalSavings)?.toLocaleString()}</strong>} {cartDisplayMobile ? (<ChevronUp size={20} />) : (<ChevronDown size={20} />)}
                </span> 
              </h4>  
              <h4 className="wizard-title-main cart-display-desktopss">
                {/* Booking Details {" - Total Savings INR " } {totalSavings} */}
                 Booking Details {Math.round(totalSavings) > 0 &&  <strong className="amount-in-wizard total-amount-cart text-success"> {" - You Saved INR " } {Math.round(totalSavings)?.toLocaleString()}</strong> }
              </h4>  
            </div>

            {
              isSmallScreen && cartDisplayMobile ? (<div className="mobile-cart-display">
                <div className="accordion p-2 pl-0" id="room-details">
          
          {selectedRoom?.length > 0
            ? selectedRoom.map((room, index) => (
                <div className="accordion-item pl-0" key={room?.id || index}>
                  {room?.roomId && room?.roomName ? (
                    <>
                      {room?.adults + room?.children > room.maxGuest && (
                        <div>
                          <p style={{ color: "red" }}>
                            * Maximum {room.maxGuest} guests are allowed
                          </p>
                        </div>
                      )}

                      {room?.adults > room.maxAdult && (
                        <div>
                          <p style={{ color: "red" }}>
                            * Maximum{" "}
                            {room.maxAdult} adults are allowed
                          </p>
                        </div>
                      )}
                      {room?.children > room.maxChildren && (
                        <div>
                          <p style={{ color: "red" }}>
                            * Maximum{" "}
                            {room.maxChildren} children are allowed
                          </p>
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      className="room-placeholder room-count-d-flex"
                      style={{
                        width: "auto",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        margin: "0px",
                      }}
                      onClick={() => {
                        openPropertyPage(room?.id);
                        onClose(room?.id);
                      }}
                    >
                      <p className="f-12-new mb-0">
                        Room {index + 1} : &nbsp;
                        <span className="span-underline">Select Room </span>
                      </p>
                    </div>
                  )}

                  {room?.roomId && room?.roomName ? (
                    <div className="row p-2 pt-0">
                      <div className="col-9 p-0">
                        <h5 className="h6 selectedRoomNameInWizard">{room.roomName}</h5>
                      </div>
                      {!isRatePing && <div className="col-3 p-0 text-end pe-0">
                          <div className="col-12 text-end p-0 pe-0">
                            <button  onClick={() => {
                                openPropertyPage(room?.id);
                                onClose(room?.id);
                              }}  className="modifytext-new-wizard">
                              <span>Modify</span>
                              <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
                            </button>

                          </div>
                      </div>}
                      {/* <div className="col-3 p-0 text-end">
                          <div className="col-9 text-end p-0">
                            <button  onClick={() => {
                                openPropertyPage(room?.id);
                                onClose(room?.id);
                              }}  className="modifytext-new-wizard">
                              <span>Modify</span>
                              <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
                            </button>

                          </div>
                      </div> */}
                      {/* <div className="package-d-flex-new">
                        <p className="f-12-new">{room?.roomPackage} -</p>
                        <h6 className="f-14-new" >
                          {isFinite(room?.packageRate) && room?.packageRate != 0
                            ?  <>INR{" "} {Math.round(room?.packageRate).toLocaleString()}</>
                            :  <div className="f-14-new text-danger" > Sold Out
                              <span className="small-text-for-today text-danger"> (for today)</span>
                              </div>
                            }
                        </h6>
                      </div> */}
                      
                      <div className="package-d-flex-new">
                        <p className="f-12-new">{room?.roomPackage} -</p>
                        <h6 className="f-14-new" >
                          {isFinite(room?.packageRate) && room?.packageRate != 0
                            ?  <>INR{" "} {isRatePing ? ratePingBasePrice?.toLocaleString() : Math.round(room?.packageRate).toLocaleString()}</>
                            :  <div className="f-14-new text-danger" > Sold Out
                              <span className="small-text-for-today text-danger"> (for today)</span>
                              </div>
                            }
                        </h6>
                      </div>
                    </div>
                  ) : null}
                </div>
              ))
            : null}

          <div className="accordion-item">
            <h6 className="h6 high-stay">Stay Information</h6>
            <div className="room-flex my-2">
              <p className="f-12-new">
                {formatDateDMY(selectedStartDate)} &nbsp;- &nbsp;
                {formatDateDMY(selectedEndDate)}
              </p>
              {/* <button  onClick={openDatePickerPage} className="modifytext-new-wizard">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button> */}
              {!isRatePing && <button  onClick={openDatePickerPage} className="modifytext-new-wizard">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button>}

            </div>

            {isDatePickerVisible && (
              <div className="main-bx-field mb-3 bdr-booking-bottom wizard-calender h6">
                <DatePicker
                  selectedStartDate={selectedStartDate}
                  selectedEndDate={selectedEndDate} onClose={() => {
                    setIsDatePickerVisible(!isDatePickerVisible);
              }}
                />
              </div>
            )}
            {isRoomsVisible && (
              <div className="row" >
                <div ref={roomsRef} className="col-md-12 main-bx-field filter-item me-3 bdr-booking-bottom wizard-room-manager">
                  <StayStepRoomManager onRoomChange={handleRoomChange} backgroundColor={backgroundColor}
                  onClose={() => setIsRoomsVisible(false)}
                  />
                </div>
              </div>
            )}
            {/* <div className="room-flex mb-0">
              <p className="total-member-count f-12-new">{`${totalAdults} Adults, ${totalChildren} Children, ${totalRooms} Rooms`}</p>
              <button onClick={openRoomPage}  className="modifytext-new-wizard">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button>

            </div> */}
            
            <div className="room-flex mb-0">
              <p className="total-member-count f-12-new">{`${totalAdults} Adults, ${totalChildren} Children, ${totalRooms} Rooms`}</p>
              {!isRatePing && <button onClick={openRoomPage}  className="modifytext-new-wizard pe-0">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button>}

            </div>
          </div>

          <div className="accordion-item1 amount-and-taxes border-0 p-2">
            <div className="accordion1" id="totalAmountAccordion">
              <div className="accordion-item1">
                <div className="price-d-flex-tp">
                  <button
                    className="accordion-button1 f-12-new"
                    type="button"
                    onClick={() => setaIsOpen(!aisOpen)}
                  >
                    Price{" "}
                    {aisOpen ? (
                      <ChevronUp size={10}></ChevronUp>
                    ) : (
                      <ChevronDown size={10}></ChevronDown>
                    )}
                  </button>

                  {/* {selectedRoom && (
                    <p className="amount-in-wizard mb-0">
                      INR {Math.round(basePrice).toLocaleString()}{" "}
                    </p>
                  )} */}
                  
                  {selectedRoom && (
                    <p className="amount-in-wizard mb-0">
                      INR {isRatePing ? ratePingBasePrice?.toLocaleString() :  Math.round(basePrice).toLocaleString()}{" "}
                    </p>
                  )}
                </div>

                {aisOpen && (
                  <div
                    id="totalAmountCollapse"
                    className="accordion-collapse1"
                  >
                    {selectedRoom?.length > 0
                      ? selectedRoom.map((room, index) => (
                          <div
                            className="accordion-item1 mt-2"
                            key={index}
                          >
                            {room?.roomId && room?.roomName ? (
                              <>
                              <p className="f-12-new">Room {index + 1}</p>
                                                        
                              {room?.packageRateList &&
                                Object.entries(room.packageRateList).map(([date, dateData]) => {
                                  const obp = dateData?.OBP?.[String(room.adults)] || {};
                                  const rate = parseFloat(obp?.RateBeforeTax || "0");
                                
                                  return (
                                    <div
                                      key={date}
                                      className="new-d-flex-for-room-p"
                                    >
                                      <p className="f-12-new mb-0">{formatDate(date)}</p>
                                      {/* <h6 className="f-12-new mb-0">
                                        INR {isFinite(rate).toLocaleString() ? Math.round(rate).toLocaleString() : 0}
                                      </h6> */}
                                      <h6 className="f-12-new mb-0 mb-1">
                                        INR {isRatePing ? ratePingBasePrice?.toLocaleString() : (isFinite(rate).toLocaleString() ? Math.round(rate).toLocaleString() : 0)}
                                      </h6>
                                    </div>
                                  );
                                })}
                            </>

                            ) : null}
                          </div>
                        ))
                      : null}
                  </div>
                )}
              </div>
            </div>
                  <div className="d-flex justify-content-between align-items-center w-100 mt-2">
                      <button
                        className="accordion-button1 f-12-new"
                        type="button"
                        onClick={() => setaIsOpen1(!aisOpen1)}
                      >
                        Taxes & Fees{" "}
                        {aisOpen1 ? (
                          <ChevronUp size={10}></ChevronUp>
                        ) : (
                          <ChevronDown size={10}></ChevronDown>
                        )}
                      </button> 
                      <p className="amount-in-wizard mb-0">
                        INR{" "}
                        {taxList &&
                          (() => {
                            const totalTax = Object.values(taxList).reduce(
                              (sum, val) => sum + parseFloat(val || 0),
                              0
                            );

                            return (
                              <>
                                {/* {(totalTax).toLocaleString()} */}
                                {isRatePing ? ratePingTaxPrice?.toLocaleString() : (totalTax).toLocaleString()}
                              </>
                            );
                          })()}
                      </p>

                  </div>
                

                  {aisOpen1 && (
                    <div
                      id="totalAmountCollapse1"
                      className="accordion-collapse1"
                    >
                      <div className="accordion-body1">
                        {selectedRoom && (
                          <div className="mt-2">
                            
                              <div className="accordion-body1">
                                {selectedRoom && (
                                  <div className="mt-2">
                                    {/* {taxList && 
                                      Object.entries(isRatePing ? ratePingTaxList : taxList).map(([taxName, taxValue]) => {
                                        // If the key is ALL CAPS, keep as is; else split camel case
                                        const formattedKey = /^[A-Z]+$/.test(taxName)
                                          ? taxName
                                          : taxName
                                              .replace(/([A-Z])/g, " $1")
                                              .replace(/^./, (str) => str.toUpperCase())
                                              .trim();
                                      
                                        return (
                                          <p key={taxName} className="f-12-new mb-0 taxe-below-txt">
                                            {formattedKey}: {taxValue?.toLocaleString()}
                                          </p>
                                        );
                                      })} */}
                                      {isRatePing
  ? ratePingTaxList?.map((tax) => (
      <p key={tax.name} className="f-12-new mb-0 taxe-below-txt">
        {tax.name}: {Number(tax.value).toLocaleString()}
      </p>
    ))
  : Object.entries(taxList || {}).map(([taxName, taxValue]) => {
      const formattedKey = /^[A-Z]+$/.test(taxName)
        ? taxName
        : taxName
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase())
            .trim();

      return (
        <p key={taxName} className="f-12-new mb-0 taxe-below-txt">
          {formattedKey}: {Number(taxValue).toLocaleString()}
        </p>
      );
    })}

                                  </div>
                                )}
                              </div>

                          </div>
                        )}
                      </div>
                    </div>
                  )}

            <div className="room-flex-1 mt-3">
              <div className="accordion1" id="totalAmountAccordion1">
                <div className="accordion-item1">
                  <h5 className="h6">
                    <b>Total</b>
                  </h5>
                </div>
              </div>
              {/* <p className="amount-in-wizard total-amount-cart">
                INR {isFinite(finalAmount).toLocaleString() ? Math.round(finalAmount).toLocaleString() : 0}
              </p> */}
              
              <p className="amount-in-wizard total-amount-cart">
                INR {isRatePing ? (ratePingBasePrice + ratePingTaxPrice)?.toLocaleString() : (isFinite(finalAmount).toLocaleString() ? Math.round(finalAmount).toLocaleString() : 0)}
              </p>
            </div>
          </div>
                </div>
              <div className="cancellation-policy p-2">
                <p className="f-12-new high-stay mb-0">Cancellation Policy</p>
                <span className="f-12-new">
                  {cancellationPolicyState?.slice(0, 35)}...
                  <a
                    type="button"
                    className="policy-read-more f-12-new"
                    data-bs-toggle="modal"
                    data-bs-target="#rateDetailsModal-b"
                  >
                    more info
                  </a>
                </span>
              </div>
              </div> ) : (
                <>
                {isSmallScreen ? (<div className="notshowing-indesktop">
              <div className="accordion-item">
            <div className="room-flex my-2">
              <p className="f-12-new">
                {formatDateDMY(selectedStartDate)} &nbsp;- &nbsp;
                {formatDateDMY(selectedEndDate)}
              </p>
              {/* <button  onClick={openDatePickerPage} className="modifytext-new-wizard">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button> */}
              {!isRatePing && <button  onClick={openDatePickerPage} className="modifytext-new-wizard">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button>}

            </div>

            {isDatePickerVisible && (
              <div className="main-bx-field mb-3 bdr-booking-bottom wizard-calender h6">
                <DatePicker
                  selectedStartDate={selectedStartDate}
                  selectedEndDate={selectedEndDate} onClose={() => {
                    setIsDatePickerVisible(!isDatePickerVisible);
              }}
                />
              </div>
            )}

            {isRoomsVisible && (
              <div className="row">
                <div ref={roomsRef} className=" col-md-12 main-bx-field filter-item me-3 bdr-booking-bottom wizard-room-manager">
                  {/* <StayStepRoomManager onRoomChange={handleRoomChange} onClose={() => {
                    setIsRoomsVisible(!isRoomsVisible);
              }}/> */}
              <StayStepRoomManager onRoomChange={handleRoomChange} backgroundColor={backgroundColor}
                  onClose={() => setIsRoomsVisible(false)}
                  />
                </div>
              </div>
            )}
            <div className="room-flex mb-0">
              <p className="total-member-count f-12-new">{`${totalAdults} Adults, ${totalChildren} Children, ${totalRooms} Rooms`}</p>
              {/* <button onClick={openRoomPage}  className="modifytext-new-wizard">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button> */}
                {!isRatePing && <button onClick={openRoomPage}  className="modifytext-new-wizard pe-0">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button>}
            </div>
          </div>  <div className="room-flex-1 mt-3">
              <div className="accordion1" id="totalAmountAccordion1">
                <div className="accordion-item1">
                  <h5 className="h6">
                    <b>Total</b>
                  </h5>
                </div>
              </div>
              <p className="amount-in-wizard total-amount-cart text-green-600 cart-amnt-txtsss">
                {/* INR {isFinite(finalAmount).toLocaleString() ? Math.round(finalAmount).toLocaleString() : 0} */}
              INR {isRatePing ? (ratePingBasePrice + ratePingTaxPrice)?.toLocaleString() : (isFinite(finalAmount).toLocaleString() ? Math.round(finalAmount).toLocaleString() : 0)}
              </p>
            </div> 
              </div>) :(
<div className="desktop-cart-display">
                <div className="accordion p-2 pl-0" id="room-details">
          
          {selectedRoom?.length > 0
            ? selectedRoom.map((room, index) => (
                <div className="accordion-item pl-0" key={room?.id || index}>
                  {room?.roomId && room?.roomName ? (
                    <>
                      {room?.adults + room?.children > room.maxGuest && (
                        <div>
                          <p style={{ color: "red" }}>
                            * Maximum {room.maxGuest} guests are allowed
                          </p>
                        </div>
                      )}

                      {room?.adults > room.maxAdult && (
                        <div>
                          <p style={{ color: "red" }}>
                            * Maximum{" "}
                            {room.maxAdult} adults are allowed
                          </p>
                        </div>
                      )}
                      {room?.children > room.maxChildren && (
                        <div>
                          <p style={{ color: "red" }}>
                            * Maximum{" "}
                            {room.maxChildren} children are allowed
                          </p>
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      className="room-placeholder room-count-d-flex"
                      style={{
                        width: "auto",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        margin: "0px",
                      }}
                      onClick={() => {
                        openPropertyPage(room?.id);
                        onClose(room?.id);
                      }}
                    >
                      <p className="f-12-new mb-0">
                        Room {index + 1} : &nbsp;
                        <span className="span-underline">Select Room </span>
                      </p>
                    </div>
                  )}

                  {room?.roomId && room?.roomName ? (
                    <div className="row p-2 pt-0">
                      <div className="col-9 p-0">
                        <h5 className="h6 selectedRoomNameInWizard">{room.roomName}</h5>
                      </div>
                      {/* <div className="col-3 p-0 text-end">
                          <div className="col-9 text-end p-0">
                            <button  onClick={() => {
                                openPropertyPage(room?.id);
                                onClose(room?.id);
                              }}  className="modifytext-new-wizard">
                              <span>Modify</span>
                              <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
                            </button>

                          </div>
                      </div> */}
                      {!isRatePing && <div className="col-3 p-0 text-end">
                          <div className="col-12 text-end p-0 pe-0">
                            <button  onClick={() => {
                                openPropertyPage(room?.id);
                                onClose(room?.id);
                              }}  className="modifytext-new-wizard pe-0">
                              <span>Modify</span>
                              <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
                            </button>

                          </div>
                      </div>}
                      <div className="package-d-flex-new">
                        <p className="f-12-new">{room?.roomPackage} -</p>
                        <h6 className="f-14-new">
                          
                          {/* {isFinite(room?.packageRate) && room?.packageRate != 0
                            ?  <>INR{" "} {Math.round(room?.packageRate).toLocaleString()}</>
                            :  <div className="f-14-new text-danger" > Sold Out
                              <span className="small-text-for-today text-danger"> (for today)</span>
                              </div>
                            } */}
                            {isFinite(room?.packageRate) && room?.packageRate != 0
                            ?  <>INR{" "} {isRatePing ? ratePingBasePrice?.toLocaleString() : Math.round(room?.packageRate).toLocaleString()}</>
                            :  <div className="f-14-new text-danger" > Sold Out
                              <span className="small-text-for-today text-danger"> (for today)</span>
                              </div>
                            }
                        </h6>
                      </div>
                    </div>
                  ) : null}
                </div>
              ))
            : null}

          <div className="accordion-item">
            <h6 className="h6 high-stay">Stay Information</h6>
            <div className="room-flex my-2">
              <p className="f-12-new">
                {formatDateDMY(selectedStartDate)} &nbsp;- &nbsp;
                {formatDateDMY(selectedEndDate)}
              </p>
              {/* <button  onClick={openDatePickerPage} className="modifytext-new-wizard">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button> */}
              {!isRatePing && <button  onClick={openDatePickerPage} className="modifytext-new-wizard pe-0">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button>}

            </div>

            {isDatePickerVisible && (
              <div className="main-bx-field mb-3 bdr-booking-bottom wizard-calender h6">
                <DatePicker
                  selectedStartDate={selectedStartDate}
                  selectedEndDate={selectedEndDate} onClose={() => {
                    setIsDatePickerVisible(!isDatePickerVisible);
              }}
                />
              </div>
            )}

            {isRoomsVisible && (
              <div className="row">
                <div ref={roomsRef} className=" col-md-12 main-bx-field filter-item me-3 bdr-booking-bottom wizard-room-manager">
                  {/* <StayStepRoomManager onRoomChange={handleRoomChange} onClose={() => {
                    setIsRoomsVisible(!isRoomsVisible);
              }}/> */}
              <StayStepRoomManager onRoomChange={handleRoomChange} backgroundColor={backgroundColor}
                  onClose={() => setIsRoomsVisible(false)}
                  />
                </div>
              </div>
            )}
            <div className="room-flex mb-0">
              <p className="total-member-count f-12-new">{`${totalAdults} Adults, ${totalChildren} Children, ${totalRooms} Rooms`}</p>
              {/* <button onClick={openRoomPage}  className="modifytext-new-wizard">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button> */}
              {!isRatePing && <button onClick={openRoomPage}  className="modifytext-new-wizard pe-0">
                <span>Modify </span>
                <FontAwesomeIcon className="cursor-pointer icons-neww" icon={faEdit} />
              </button>}
            </div>
          </div>

          <div className="accordion-item1 amount-and-taxes border-0 p-2">
            <div className="accordion1" id="totalAmountAccordion">
              <div className="accordion-item1">
                <div className="price-d-flex-tp">
                  <button
                    className="accordion-button1 f-12-new"
                    type="button"
                    onClick={() => setaIsOpen(!aisOpen)}
                  >
                    Price{" "}
                    {aisOpen ? (
                      <ChevronUp size={10}></ChevronUp>
                    ) : (
                      <ChevronDown size={10}></ChevronDown>
                    )}
                  </button>

                  {/* {selectedRoom && (
                    <p className="amount-in-wizard mb-0">
                      INR {Math.round(basePrice).toLocaleString()}{" "}
                    </p>
                  )} */}
                  
                  {selectedRoom && (
                    <p className="amount-in-wizard mb-0">
                      INR {isRatePing ? ratePingBasePrice?.toLocaleString() : Math.round(basePrice).toLocaleString()}{" "}
                    </p>
                  )}
                </div>

                {aisOpen && (
                  <div
                    id="totalAmountCollapse"
                    className="accordion-collapse1"
                  >
                    {selectedRoom?.length > 0
                      ? selectedRoom.map((room, index) => (
                          <div
                            className="accordion-item1 mt-2"
                            key={index}
                          >
                            {room?.roomId && room?.roomName ? (
                              // <>
                              //   <p className="f-12-new">Room {index + 1}</p>
                              //   {selectedRoom && (
                              //     <div className="new-d-flex-for-room-p">
                              //       <p className="f-12-new mb-0">
                              //         {formatDate(selectedStartDate)}
                              //       </p>
                              //       <h6 className="f-12-new mb-0">
                              //         INR{" "}
                              //         {isFinite(room?.packageRate).toLocaleString()
                              //           ? Math.round(room?.packageRate).toLocaleString()
                              //           : 0}
                              //       </h6>
                              //     </div>
                              //   )}
                              // </>
                              
                              <>
                              <p className="f-12-new">Room {index + 1}</p>
                                                        
                              {room?.packageRateList &&
                                Object.entries(room.packageRateList).map(([date, dateData]) => {
                                  const obp = dateData?.OBP?.[String(room.adults)] || {};
                                  const rate = parseFloat(obp?.RateBeforeTax || "0");
                                
                                  // return (
                                  //   <div
                                  //     key={date}
                                  //     className="new-d-flex-for-room-p"
                                  //   >
                                  //     <p className="f-12-new mb-0">{formatDate(date)}</p>
                                  //     <h6 className="f-12-new mb-0">
                                  //       INR {isFinite(rate).toLocaleString() ? Math.round(rate).toLocaleString() : 0}
                                  //     </h6>
                                  //   </div>
                                  // );

                                  
                                  return (
                                    <div
                                      key={date}
                                      className="new-d-flex-for-room-p"
                                    >
                                      <p className="f-12-new mb-0">{formatDate(date)}</p>
                                      <h6 className="f-12-new mb-0 mb-1">
                                       {isFinite(room?.packageRate) && room?.packageRate != 0
                            ?  <>INR{" "} {isRatePing ? ratePingBasePrice?.toLocaleString() : Math.round(room?.packageRate).toLocaleString()}</>
                            :  <div className="f-14-new text-danger" > Sold Out
                              <span className="small-text-for-today text-danger"> (for today)</span>
                              </div>
                            } </h6>
                                    </div>
                                  );
                                })}
                            </>
                            ) : null}
                          </div>
                        ))
                      : null}
                  </div>
                )}
              </div>
            </div>
                  <div className="d-flex justify-content-between align-items-center w-100 mt-2">
                      <button
                        className="accordion-button1 f-12-new"
                        type="button"
                        onClick={() => setaIsOpen1(!aisOpen1)}
                      >
                        Taxes & Fees{" "}
                        {aisOpen1 ? (
                          <ChevronUp size={10}></ChevronUp>
                        ) : (
                          <ChevronDown size={10}></ChevronDown>
                        )}
                      </button> 
                      <p className="amount-in-wizard mb-0">
                        
                          {isTaxCalculated ? (<>
                INR{" "}
                        {taxList &&
                          (() => {
                            const totalTax = Object.values(taxList).reduce(
                              (sum, val) => sum + parseFloat(val || 0),
                              0
                            );

                            return (
                              // <>
                              //   {(totalTax).toLocaleString()}
                              // </>

                               <>
                                {isRatePing ? ratePingTaxPrice?.toLocaleString() : (totalTax).toLocaleString()}
                              </>

                            );
                          })()}
                </>) :(<> ...</>)}
                      </p>

                  </div>
                

                  {aisOpen1 && (
                    <div
                      id="totalAmountCollapse1"
                      className="accordion-collapse1"
                    >
                      <div className="accordion-body1">
                        {selectedRoom && (
                          <div className="mt-2">
                            {/* {taxList &&
                              // Object.entries(taxList).map(
                              //   ([taxName, taxValue]) =>
                              //     parseFloat(taxValue) > 0.0 ? (
                              //       <p
                              //         key={taxName}
                              //         className="f-12-new mb-0 taxe-below-txt"
                              //       >
                              //         {taxName}: INR {(taxValue).toLocaleString()}
                              //       </p>
                              //     ) : null
                              // )
                              Object.entries(taxList).map(([taxName, taxValue]) => {
                                const formattedKey = taxName
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/^./, str => str.toUpperCase())
                                    .trim()
                                    .replace(/\bG S T\b/, "GST");
                                return parseFloat(taxValue) > 0.0 ? (
                                  <p key={taxName}
                                     className="f-12-new mb-0 taxe-below-txt">
                                    {formattedKey}: INR {(taxValue)?.toLocaleString()}
                                  </p>
                                ) : null;
                              })
                              } */}
                              <div className="accordion-body1">
                              {selectedRoom && (
                                <div className="mt-2">
                                  {/* {taxList &&
                                    Object.entries(isRatePing ? ratePingTaxList : taxList).map(([taxName, taxValue]) => {
                                      // If the key is ALL CAPS, keep as is; else split camel case
                                      const formattedKey = /^[A-Z]+$/.test(taxName)
                                        ? taxName
                                        : taxName
                                            .replace(/([A-Z])/g, " $1")
                                            .replace(/^./, (str) => str.toUpperCase())
                                            .trim();
                                    
                                      return (
                                         <p key={taxName} className="f-12-new mb-0 taxe-below-txt">
                                          {formattedKey}: {taxValue?.toLocaleString()}
                                        </p>
                                      );
                                    })} */}
                                    {isRatePing
  ? ratePingTaxList?.map((tax) => (
      <p key={tax.name} className="f-12-new mb-0 taxe-below-txt">
        {tax.name}: {Number(tax.value).toLocaleString()}
      </p>
    ))
  : Object.entries(taxList || {}).map(([taxName, taxValue]) => {
      const formattedKey = /^[A-Z]+$/.test(taxName)
        ? taxName
        : taxName
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase())
            .trim();

      return (
        <p key={taxName} className="f-12-new mb-0 taxe-below-txt">
          {formattedKey}: {Number(taxValue).toLocaleString()}
        </p>
      );
    })}
                                </div>
                              )}
                            </div>

                          </div>
                        )}
                      </div>
                    </div>
                  )}

            <div className="room-flex-1 mt-3">
              <div className="accordion1" id="totalAmountAccordion1">
                <div className="accordion-item1">
                  <h5 className="h6">
                    <b>Total</b>
                  </h5>
                </div>
              </div>
              <p className="amount-in-wizard total-amount-cart">
                {/* {isTaxCalculated ? (<>
                INR {isFinite(finalAmount).toLocaleString() ? Math.round(finalAmount).toLocaleString() : 0}
                </>) :(<> ...</>)} */}

                {isTaxCalculated ? (<>
                INR {isRatePing ? (ratePingBasePrice + ratePingTaxPrice)?.toLocaleString() : (isFinite(finalAmount).toLocaleString() ? Math.round(finalAmount).toLocaleString() : 0)}
                </>) :(<> ...</>)}
              </p>
            </div>
          </div>
                </div>
              <div className="cancellation-policy p-2">
                <p className="f-12-new high-stay mb-0">Cancellation Policy</p>
                <span className="f-12-new">
                  {cancellationPolicyState?.slice(0, 35)}...
                  <a
                    type="button"
                    className="policy-read-more f-12-new"
                    data-bs-toggle="modal"
                    data-bs-target="#rateDetailsModal-b"
                  >
                    more info
                  </a>
                </span>
              </div>
            </div>
              ) }
                </>
              )
            }
              




            
        </div>

        {typeof window !== "undefined" && ReactDOM.createPortal(
          <div
            className="modal fade"
            id="rateDetailsModal-b"
            tabIndex="-1"
            aria-labelledby="rateDetailsModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg text-start">
              <div className="modal-content" style={{backgroundColor: "#fcfcfc"}}>
                <div className="p-3  text-start">
                  <h5 className="modal-title">Cancellation Policy</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style={{background: backgroundColor}}
                  >
                    x
                  </button>
                </div>
                <div className="modal-body">

                  <div className="mt-0">
                    {/* <p>{cancellationPolicyState}</p> */}
                    <div className="cancellation-popicy-up" dangerouslySetInnerHTML={{ __html: cancellationPolicyState }} />
                  </div>
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}
      </div>
    </>
  );
};

export default StayStep;
